import { render, staticRenderFns } from "./profit.vue?vue&type=template&id=343d1713"
import script from "./profit.vue?vue&type=script&lang=js"
export * from "./profit.vue?vue&type=script&lang=js"
import style0 from "./profit.vue?vue&type=style&index=0&id=343d1713&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports